/**
 * Persist and retrieve filter values
 * @param  {String}   id       Unique id of the compoment to be saved and retreived by
 * @param  {Object}   init      Initial state
 *
 * This hook can be used in place of useState with the addition of id, initital state
 * Example Usage:
 *
  import usePersistentState from 'hooks/usePersistentState';

  const [toggle, setToggle] = usePersistentState(
    'togglePreference', // unique ID
    'default or initial state'
  );
 *
 */
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../authentication/AuthContext';

const usePersistentState = (id, init) => {
  const { userProfile } = useContext(AuthContext);

  const getPersistentState = () => {
    const val = JSON.parse(localStorage.getItem(`${userProfile?.sub}.state.${id}`));

    return val || init;
  };

  const [state, setState] = useState(getPersistentState());

  useEffect(() => {
    localStorage.setItem(`${userProfile?.sub}.state.${id}`, JSON.stringify(state));
  }, [state, id, userProfile?.sub]);

  return [state, setState];
};

export default usePersistentState;
